import { Box, Button } from "@mui/material";
import FilterAltOffOutlinedIcon from "@mui/icons-material/FilterAltOffOutlined";

/**
 * FilterBar — Phase 2 reusable component.
 *
 * A layout wrapper that arranges a SearchInput plus arbitrary filter
 * controls (dropdowns, date pickers, chips) in a consistent responsive row,
 * with an optional "Clear filters" action. It does not own or interpret any
 * filter state itself — each page keeps its own existing filter state
 * variables (e.g. JobRequirements' filterCompany/filterRecruiter/fromDate/
 * toDate) and passes them in as children; this component only standardizes
 * the surrounding layout.
 *
 * Props:
 *   children     - the search box + filter controls to lay out (required)
 *   activeCount  - number of currently-active filters, used to decide
 *                  whether to show the "Clear filters" button (default 0)
 *   onClear      - called when "Clear filters" is clicked; only rendered
 *                  if onClear is provided and activeCount > 0
 */
export default function FilterBar({ children, activeCount = 0, onClear }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 1.25,
        p: 1.5,
        bgcolor: "#fff",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        mb: 2,
      }}
    >
      {children}

      {onClear && activeCount > 0 && (
        <Button
          size="small"
          color="inherit"
          startIcon={<FilterAltOffOutlinedIcon fontSize="small" />}
          onClick={onClear}
          sx={{ ml: "auto", flexShrink: 0, color: "text.secondary" }}
        >
          Clear filters ({activeCount})
        </Button>
      )}
    </Box>
  );
}
